import React from 'react'

import { Details, Row, Block } from '../../components/details/details'
import { Collection, Group } from '../../components/details/collection'

import QAServicingCardContainer from '../../containers/qa-servicings/qa-servicing-card-container'

export default ({
  qaWorkOrder,
  locationModel,
  accountManagers,
  qaServicings,

  loading,
  location,

  children,

  hasNextPage,
  onLoadNextPage
}) => {
  if (loading) return <p>Loading...</p>

  return (
    <div>
      <Details leaveRoomForControls>
        <Row>
          <Block title='location'>
            <p>{locationModel.name}</p>
          </Block>
          <Block title='date'>
            <p>{qaWorkOrder.createdAt.format('MMMM Do, YYYY')}</p>
          </Block>
          <Block title='managers'>
            <p>{accountManagers.map(am => am.name).join(', ') || '—'}</p>
          </Block>
        </Row>
        <Row>
          <Block title='address'>
            <p>{locationModel.address}</p>
          </Block>
          <Block title='contact'>
            <p>{qaWorkOrder.contact || '—'}</p>
          </Block>
        </Row>
      </Details>
      <Collection actionType='add' actionLink={`${location.pathname}/areas/create`}>
        <div className='list'>
          <Group title='areas'>
            {qaServicings.map((servicing) =>
              <QAServicingCardContainer
                qaWorkOrderId={qaWorkOrder.id}
                key={servicing.id}
                id={servicing.id}
              />)}

            {hasNextPage &&
              <div className='card load-more' onClick={onLoadNextPage}>
                Load more...
              </div>}
          </Group>
        </div>
      </Collection>
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/qa-work-orders/qa-work-order-details.js